import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ text = "Loading..." }) => {
  return (
    <div className="loading-screen" role="alert" aria-busy="true">
      <div className="egg-wrapper">
        <div className="egg-white"></div>
        <div className="egg-yolk"></div>
      </div>
      <h1 className="loading-text">{text}</h1>
    </div>
  );
};

export default LoadingScreen;